export const types = {
  'SET_REFRESH_SERVICE_TICKET_STATUS': 'SET_REFRESH_SERVICE_TICKET_STATUS',
  'SET_SERVICE_TICKET': 'SET_SERVICE_TICKET',
  'SET_SERVICE_TICKET_LOADING': 'SET_SERVICE_TICKET_LOADING',
  'SET_SERVICE_TICKET_STREAM': 'SET_SERVICE_TICKET_STREAM',
  'SET_OPEN_SERVICE_TICKET_LOADING': 'SET_OPEN_SERVICE_TICKET_LOADING',
  'SET_OPEN_SERVICE_TICKET': 'SET_OPEN_SERVICE_TICKET',
  'SET_OPEN_SERVICE_TICKET_OBJECT': 'SET_OPEN_SERVICE_TICKET_OBJECT',
  'SET_CLEAR_OPEN_SERVICE_TICKET_OBJECT': 'SET_CLEAR_OPEN_SERVICE_TICKET_OBJECT',
  'SET_OPEN_TICKET_FILTER_STATE': 'SET_OPEN_TICKET_FILTER_STATE',
  'SET_CLEAR_TICKET_FILTER_STATE': 'SET_CLEAR_OPEN_TICKET_FILTER_STATE',
  'SET_SERVICE_TICKET_NOTIFICATION': 'SET_SERVICE_TICKET_NOTIFICATION',
  'SET_PREVIOUS_SERVICE_TICKET_CURSOR': 'SET_PREVIOUS_SERVICE_TICKET_CURSOR',
  'SET_NEXT_SERVICE_TICKET_CURSOR': 'SET_NEXT_SERVICE_TICKET_CURSOR',
  'SET_SERVICE_TICKET_TOTAL': 'SET_SERVICE_TICKET_TOTAL',
  'SET_CURRENT_SERVICE_TICKET_PAGE_INDEX': 'SET_CURRENT_SERVICE_TICKET_PAGE_INDEX',
  'SET_CURRENT_SERVICE_TICKET_PAGE_SIZE': 'SET_CURRENT_SERVICE_TICKET_PAGE_SIZE',
  'SET_SERVICE_TICKET_SEARCH_KEYWORD': 'SET_SERVICE_TICKET_SEARCH_KEYWORD',
  'SET_SELECTED_CUSTOMERS': 'SET_SELECTED_CUSTOMERS',
  'GET_SERVICE_TICKET_DETAIL': 'GET_SERVICE_TICKET_DETAIL',
  'SET_TICKET_2_JOB': 'SET_TICKET_2_JOB',
  'IS_HOME_OCCUPIED': 'IS_HOME_OCCUPIED',
};
